import { LegalDoc } from '@/components/LegalDoc';

export function PaymentInfoPage() {
  return (
    <LegalDoc title="Порядок проведения оплаты и безопасность" effectiveFrom="01.01.2026">
      <p>
        Настоящий документ описывает порядок проведения оплаты при использовании сервиса
        «Empire of Life» и меры безопасности, применяемые для защиты платежей
        Пользователей.
      </p>

      <h2>1. Получатель платежа</h2>
      <p>
        Пополнение внутреннего баланса проводится через подключённые платёжные сервисы.
        После успешной оплаты Пользователю доступна информация об операции в истории
        пополнений и покупок.
      </p>

      <h2>2. Способы оплаты</h2>
      <p>На Сайте доступны следующие способы пополнения внутреннего баланса:</p>
      <ul>
        <li><strong>ЮKassa / YooMoney</strong> - оплата банковской картой РФ (Mir, Visa, MasterCard, в зависимости от доступности у эквайера), через систему быстрых платежей (СБП), кошелёк YooMoney и иные методы, поддерживаемые сервисом ЮKassa.</li>
        <li><strong>CryptoBot</strong> - оплата криптовалютой (USDT, TON, BTC, ETH, LTC и др.) через Telegram-бот @CryptoBot. Конкретная криптовалюта выбирается Пользователем при оплате. Курс к рублю фиксируется на стороне сервиса CryptoBot в момент создания счёта.</li>
      </ul>

      <h2>3. Валюта расчётов</h2>
      <p>
        Расчёты с Пользователем производятся в рублях Российской Федерации. Внутренний
        баланс ведётся в рублях. Криптовалютные платежи конвертируются в рублёвый эквивалент
        автоматически.
      </p>

      <h2>4. Цены</h2>
      <ul>
        <li>Цены на Виртуальные товары указываются на Сайте в рублях РФ.</li>
        <li>Оператор оставляет за собой право в одностороннем порядке изменять цены. Цена, по которой совершена покупка, не пересматривается.</li>
      </ul>

      <h2>5. Порядок проведения платежа</h2>
      <p>Платёж проводится по следующей схеме:</p>
      <ul>
        <li>Пользователь указывает сумму пополнения и выбирает способ оплаты.</li>
        <li>Сайт создаёт счёт у платёжного провайдера и переадресует Пользователя на страницу оплаты.</li>
        <li>Платёж производится <strong>непосредственно на стороне платёжного провайдера</strong>. Сайт не получает и не хранит реквизиты банковских карт и иные платёжные секреты Пользователя.</li>
        <li>По факту успешной оплаты провайдер направляет уведомление (webhook) на серверы Сайта.</li>
        <li>Уведомление проверяется на подлинность средствами провайдера; при успешной проверке внутренний баланс Пользователя увеличивается на соответствующую сумму.</li>
        <li>Покупка Виртуальных товаров производится списанием с внутреннего баланса. Доставка товара на Сервер происходит автоматически в течение нескольких секунд (при технической доступности Сервера).</li>
      </ul>

      <h2>6. Безопасность платежей</h2>
      <ul>
        <li>Соединение с Сайтом защищено протоколом HTTPS с использованием актуального TLS-сертификата.</li>
        <li>Webhook YooKassa перепроверяется запросом к API YooKassa по идентификатору платежа; webhook CryptoBot проверяется подписью HMAC-SHA256.</li>
        <li>Платёжные провайдеры (ЮKassa, CryptoBot) соответствуют требованиям PCI DSS и иным отраслевым стандартам безопасности.</li>
        <li>Внутренние операции по балансу выполняются атомарно с использованием механизмов СУБД, что исключает двойное списание или начисление средств.</li>
        <li>Все операции с балансом и покупки фиксируются в журналах системы.</li>
      </ul>

      <h2>7. Идемпотентность зачисления</h2>
      <p>
        Каждая транзакция имеет уникальный идентификатор, полученный от платёжного
        провайдера. Повторное получение уведомления об оплате по одной и той же
        транзакции не приводит к повторному зачислению средств на внутренний баланс.
      </p>

      <h2>8. Возврат денежных средств и отмена</h2>
      <ul>
        <li>В соответствии с п. 4 ст. 26.1 Закона РФ № 2300-1 «О защите прав потребителей» цифровые услуги, оказываемые мгновенно (в том числе Виртуальные товары), возврату не подлежат.</li>
        <li>Денежные средства, поступившие на внутренний баланс, возврату не подлежат.</li>
        <li>В исключительных случаях (ошибочное двойное списание, доказанный технический сбой, оплата без последующего получения товара по вине Администрации) рассматривается индивидуальный возврат.</li>
        <li>Заявление на возврат направляется на адрес <a href="mailto:eol.servermc@gmail.com" className="text-eol-pink underline">eol.servermc@gmail.com</a> с описанием ситуации и приложением подтверждающих документов (скриншоты, чеки). Срок рассмотрения — до 30 календарных дней.</li>
        <li>Решение принимается Администрацией с учётом фактических обстоятельств и положений настоящего документа.</li>
      </ul>

      <h2>9. Подтверждение оплаты</h2>
      <p>
        Подтверждение операции предоставляется Пользователю по запросу на email{' '}
        <a href="mailto:eol.servermc@gmail.com" className="text-eol-pink underline">eol.servermc@gmail.com</a> с указанием
        даты, суммы платежа и идентификатора транзакции.
      </p>

      <h2>10. Ограничения</h2>
      <ul>
        <li>Минимальная и максимальная суммы платежа определяются Сайтом и платёжным провайдером и могут изменяться.</li>
        <li>Сайт оставляет за собой право отказать в проведении операции при подозрении на мошенничество.</li>
        <li>В случае установления факта мошеннического платежа Администрация вправе аннулировать соответствующее зачисление и заблокировать аккаунт Пользователя.</li>
      </ul>

      <h2>11. Контакты по вопросам оплаты</h2>
      <ul>
        <li>Email: <a href="mailto:eol.servermc@gmail.com" className="text-eol-pink underline">eol.servermc@gmail.com</a></li>
        <li>Telegram-поддержка: <a href="https://t.me/eol_support" target="_blank" rel="noreferrer" className="text-eol-pink underline">@eol_support</a></li>
        <li>Discord: <a href="https://discord.gg/KRfDxZDUfZ" target="_blank" rel="noreferrer" className="text-eol-pink underline">discord.gg/KRfDxZDUfZ</a></li>
      </ul>
    </LegalDoc>
  );
}
